import { render, staticRenderFns } from "./receivemoney.vue?vue&type=template&id=46e7faa4&"
import script from "./receivemoney.vue?vue&type=script&lang=js&"
export * from "./receivemoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports